import { LOADER_START, LOADER_STOP } from './actionTypes';


export const loaderActions = {
  start,
  stop
};

function start() {
  return { type: LOADER_START };
}


function stop() {
  return { type: LOADER_STOP };
}
